<!-- ── CABECERA ── -->
<div mat-dialog-title class="fi-dialog-header">
  <div class="fi-dialog-title">
    <div class="fi-dialog-icon">
      <mat-icon>label_outline</mat-icon>
    </div>
    <span>{{ item.product ? 'Editar concepto' : 'Nuevo concepto' }}</span>
  </div>
  <button mat-icon-button (click)="onCancel()" class="fi-close-btn" aria-label="Cerrar">
    <mat-icon>close</mat-icon>
  </button>
</div>

<!-- ── CONTENIDO ── -->
<mat-dialog-content class="fi-content">
  <div class="row g-3">

    <!-- Concepto (ancho completo) -->
    <div class="col-12">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Concepto</mat-label>
        <mat-icon matPrefix class="fi-prefix-icon">label_outline</mat-icon>
        <input matInput [(ngModel)]="item.product" placeholder="Buscar o escribir concepto…"
          [matAutocomplete]="auto" [formControl]="conceptCtrl"
          required autocomplete="off">
        <mat-autocomplete #auto="matAutocomplete">
          <mat-option *ngFor="let concept of filteredConcepts | async; trackBy: trackByIndex"
            [value]="concept.name" (click)="displayFn(concept)">
            {{ concept.name }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </div>

    <!-- Unidades -->
    <div class="col-6 col-md-4">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Unidades</mat-label>
        <input matInput [(ngModel)]="item.quantity" type="text" required numberDecimalsDirective>
      </mat-form-field>
    </div>

    <!-- Precio -->
    <div class="col-6 col-md-4">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Precio</mat-label>
        <mat-icon matSuffix class="fi-suffix-icon">attach_money</mat-icon>
        <input matInput [(ngModel)]="item.unityAmount" type="text" required numberDecimalsDirective>
      </mat-form-field>
    </div>

    <!-- Descuento -->
    <div class="col-6 col-md-4">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Descuento (%)</mat-label>
        <mat-icon matSuffix class="fi-suffix-icon">assignment</mat-icon>
        <input matInput [(ngModel)]="item.discount" type="text" numberDecimalsDirective>
      </mat-form-field>
    </div>

    <!-- Impuestos -->
    <div class="col-12">
      <div class="fi-taxes-section">
        <div class="fi-taxes-label">
          <mat-icon>receipt</mat-icon>
          <span>Impuestos</span>
        </div>
        <app-autocomplete-select
          [items]="taxes" [idField]="'id'" [displayField]="'name'"
          placeholder="Añadir impuesto…" (selectionChanged)="onSelectTax($event)"
          [classList]="'w-100'">
        </app-autocomplete-select>
        <div class="fi-chips-wrap" *ngIf="item.taxes?.length > 0">
          <convfact-chips-component
            [chipsElements]="item.taxes" [container]="this" [changeFunction]="changeChips">
          </convfact-chips-component>
        </div>
      </div>
    </div>

    <!-- Total línea -->
    <div class="col-12">
      <div class="fi-total-box">
        <span class="fi-total-label">Total línea</span>
        <span class="fi-total-value">{{ calcularTotalesLinea(item) | number:'1.2-2' }} €</span>
      </div>
    </div>

  </div>
</mat-dialog-content>

<!-- ── ACCIONES ── -->
<mat-dialog-actions class="fi-actions">
  <button mat-stroked-button (click)="onCancel()">Cancelar</button>
  <button mat-flat-button class="fi-btn-save" (click)="onSave()">
    <mat-icon>save</mat-icon> Guardar
  </button>
</mat-dialog-actions>
